import Http from '../../http';

class UserServices {
    static async login(data) {
        
        return Http.post('/user/login', data);
    }

    static async forgot(data) {
        
        return Http.post('/user/forgot', data);
    }

    static async verifyOtp(data) {
     console.log('i the verify otp', data)
    return Http.post('/user/verifyOtp', data);
    }

    static async comparePassword(data) {
        return Http.post('/user/comparePassword', data);
    }

    static async retry(data) {
        return Http.post('/user/retry', data);
    }

    static async updateUser(data) {
        
        return Http.update('/user', data);
    }
   
    // static async findTcByUser(data){
    //     return Http.get(`/user/findTcByUser/${phone_number}`);
    //     // return Http.get('/user', data);
    // }

    static async logout() {
        return Http.post('users/logout', {});
    }

   static async resendOTP(phone_number, options) {
    console.error(phone_number,options);
        const data = {
          phone_number,  // phone_number from the argument
          options        // options ('WhatsApp' in your case)
        };
    
        // Make the POST request to the /user/resendOTP endpoint with the data
        return Http.post('/user/resendOTP', data);
      }



}


export default UserServices;
